<template>
      <!--====== APPIE HERO PART START ======-->
    
    <section class="appie-hero-area appie-hero-6-area appie-hero-7-area">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-lg-7">
                    <div class="appie-hero-content appie-hero-content-6 appie-hero-content-7">
                        <h1 class="appie-title">Vos pharmacies en un clic ! </h1>
                        <p><strong>En un click, nous automatisons</strong> la liste des pharmacies dans la zone que vous avez choisie et nous vous permettrons de faire une estimation de votre ordonnance.</p>
                        <ul>
                            <li><a href="#"><i class="fab fa-apple"></i> <span>Bientôt disponible sur <span>App Store</span></span></a></li>
                            <li><a class="item-2" :href="downloadLink.android.link"><i class="fab fa-google-play"></i> <span>Disponible sur <span>Google Play</span></span></a></li>
                        </ul>
                        <div class="info">
                            
                        </div>
                    </div>
                </div>
                <div class="col-lg-5">
                    <div class="appie-hero-thumb-6">
                        <div class="thumb wow animated fadeInUp text-center" data-wow-duration="1000ms" data-wow-delay="600ms">
                            <img src="@/assets/images/hero-thumb-8.png" alt="">
                            <div class="back-image">
                                <img src="@/assets/images/hero-shape-2.png" alt="">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    
    <!--====== APPIE HERO PART ENDS ======-->
</template>

<script>
import downloadLink from "@/config/download-link";

export default {
  computed: {
    downloadLink() {
      return downloadLink
    }
  }

}
</script>

<style>

</style>
